import { computed, ref, reactive, watch, nextTick } from 'vue'
import { forEach, isEmpty, pickBy } from 'lodash-es'
import dayjs from 'dayjs'
import { useStore } from '../store/index'

const useFilterSearch = (url = 'getResumesAdmin', checks?: Record<string, boolean>) => {
  const store = useStore()
  // 翻页相关：当前页数以及每页的数量
  const currentPage = ref(1)
  const PAGE_SIZE = 10

  // 搜索过滤条件 对应一个 type 一个 value，使用下拉框和input 呈现
  // 日期范围 使用 dateRange 表示
  const searchForm = reactive({
    type: '',
    value: '',
    dateRange: ''
  })
  // 搜索被触发了
  const searchTriggered = ref(false)
  // 当 type 变换的时候，清空对应的 value
  watch(() => searchForm.type, () => {
    searchForm.value = ''
  })
  // 附加条件，已 checkbox 呈现，可以有多个，比如是否是实例等等
  // { isExamples: true, isValid: true }
  const checksRef = reactive(checks || {})
  // 生成附件条件 object，循环判断是否空
  const searchCondition = computed(() => {
    return pickBy(checksRef, (value) => value)
  })
  // 生成时间范围对应的字段
  const dataRange = computed(() => {
    if (Array.isArray(searchForm.dateRange)) {
      return searchForm.dateRange.map(item => dayjs(item).format('YYYY-MM-DD') )
    }
    return ['', '']
  })
  // 排序条件，格式为 sort=createdAt+descending,createdAt+ascending
  // eslint-disable-next-line prefer-const
  let sortCondition: Record<string, any> = {}

  // 生成过滤条件, 并且进行搜索
  const performGetList = async () => {
    await nextTick()
    const sortArr: string[] = []
    console.log('the sort', sortCondition)
    forEach(sortCondition, (value, key) => {
      sortArr.push(`${key}+${value}`)
    })
    const searchParams = {
      currentPage: currentPage.value, 
      pageSize: PAGE_SIZE,
      ...( searchTriggered.value && searchForm.value && { [searchForm.type]: searchForm.value}),
      ...( searchTriggered.value && searchForm.dateRange && { 'startDate': dataRange.value[0], 'endDate': dataRange.value[1] }),
      ...( !isEmpty(searchCondition.value) && searchCondition.value),
      ...(sortArr.length > 0 && { sort: sortArr.join(',')})
    }
    await store.dispatch(url, { searchParams })
  }
  const resetValues = () => {
    searchTriggered.value = false
    currentPage.value = 1
  }
  const onSort = async ({ prop, order }) => {
    if (prop) {
      sortCondition[prop] = order
    } else {
      sortCondition = {}
    }
    console.log(sortCondition, prop)
    await performGetList()
  }
  return {
    currentPage,
    PAGE_SIZE,
    searchForm,
    searchTriggered,
    checksRef,
    sortCondition,
    performGetList,
    resetValues,
    onSort
  }
}

export default useFilterSearch